import { ApolloLink } from '@apollo/client';

const authLink = ({ getToken }) =>
  // TODO - testing for no sessionToken should be here

  new ApolloLink((operation, forward) => {
    operation.setContext(({ headers }) => {
      const token = getToken();

      return {
        headers: {
          ...headers,
          Authorization: token ? `Bearer ${token}` : '',
        },
      };
    });

    return forward(operation);
  });

export default authLink;
